<div class="wizard-summary" data-cy="wizard-summary">
  <p>{{ 'TICKETS.VERIFICATION_WIZARD.SUMMARY.INTRO' | translate }}</p>

  @if (isStepVisible('name') && nameData) {
    <div class="wizard-summary-section">
      <h6 class="wizard-summary-title" data-cy="wizard-summary-title-name">{{ 'TICKETS.VERIFICATION_WIZARD.STEPS.NAME' | translate }}</h6>
      <dl>
        <dt>{{ 'NAME_DATA.FIRSTNAME' | translate }}</dt>
        <dd data-cy="wizard-summary-firstname">{{ nameData.firstName }}</dd>
        <dt>{{ 'NAME_DATA.LASTNAME' | translate }}</dt>
        <dd data-cy="wizard-summary-lastname">{{ nameData.lastName }}</dd>
      </dl>
    </div>
  }

  @if (isStepVisible('address') && addressData) {
    <div class="wizard-summary-section">
      <h6 class="wizard-summary-title" data-cy="wizard-summary-title-address">{{ 'TICKETS.VERIFICATION_WIZARD.STEPS.ADDRESS' | translate }}</h6>
      <dl>
        <dt>{{ 'ADDRESS_DATA.STREET' | translate }}</dt>
        <dd data-cy="wizard-summary-street">{{ addressData.street }}</dd>
        @if (addressData.addressAddition) {
          <dt>{{ 'ADDRESS_DATA.ADDRESS_ADDITION' | translate }}</dt>
          <dd data-cy="wizard-summary-address-addition">{{ addressData.addressAddition }}</dd>
        }
        <dt>{{ 'ADDRESS_DATA.POSTALCODE' | translate }}</dt>
        <dd data-cy="wizard-summary-postal-code">{{ addressData.postalCode }}</dd>
        <dt>{{ 'ADDRESS_DATA.CITY' | translate }}</dt>
        <dd data-cy="wizard-summary-city">{{ addressData.city }}</dd>
        <dt>{{ 'ADDRESS_DATA.COUNTRY' | translate }}</dt>
        <dd data-cy="wizard-summary-country">{{ addressData.country | land }}</dd>
      </dl>
    </div>
  }

  @if (isStepVisible('email') && emailData) {
    <div class="wizard-summary-section">
      <h6 class="wizard-summary-title" data-cy="wizard-summary-title-email">{{ 'TICKETS.VERIFICATION_WIZARD.STEPS.EMAIL' | translate }}</h6>
      <dl>
        <dt>{{ 'EMAIL_DATA.EMAIL' | translate }}</dt>
        <dd data-cy="wizard-summary-email">{{ emailData.email }}</dd>
      </dl>
    </div>
  }

  @if (isStepVisible('school') && schoolData) {
    <div class="wizard-summary-section">
      <h6 class="wizard-summary-title" data-cy="wizard-summary-title-school">{{ 'TICKETS.VERIFICATION_WIZARD.STEPS.SCHOOL' | translate }}</h6>
      <dl>
        <dt>{{ 'SCHOOL_DATA.SCHOOL' | translate }}</dt>
        <dd data-cy="wizard-summary-school">{{ schoolData.schuleName }}</dd>
        @if (schoolData.klasseName) {
          <dt>{{ 'SCHOOL_DATA.KLASSE' | translate }}</dt>
          <dd data-cy="wizard-summary-klasse">{{ schoolData.klasseName }}</dd>
        }
        @if (schoolData.bildungsgangName) {
          <dt>{{ 'SCHOOL_DATA.COURSE' | translate }}</dt>
          <dd data-cy="wizard-summary-bildungsgang">{{ schoolData.bildungsgangName }}</dd>
        }
        <dt>{{ 'SCHOOL_DATA.SCHOOL_YEAR' | translate }}</dt>
        <dd data-cy="wizard-summary-schuljahr">{{ schoolData.schuljahrName }}</dd>
      </dl>
    </div>
  }

  @if (isStepVisible('geschwister') && geschwisterData) {
    <div class="wizard-summary-section">
      <h6 class="wizard-summary-title" data-cy="wizard-summary-title-geschwister">{{ 'TICKETS.VERIFICATION_WIZARD.STEPS.GESCHWISTER' | translate }}</h6>
      <dl>
        <dt>{{ 'TICKETS.VERIFICATION_WIZARD.SUMMARY.GESCHWISTER_COUNT' | translate }}</dt>
        <dd data-cy="wizard-summary-geschwister-count">{{ selectedGeschwisterCount }}</dd>
      </dl>
    </div>
  }

  @if (isStepVisible('payment') && paymentData) {
    <div class="wizard-summary-section">
      <h6 class="wizard-summary-title" data-cy="wizard-summary-title-payment">{{ 'TICKETS.VERIFICATION_WIZARD.STEPS.PAYMENT' | translate }}</h6>
      <dl>
        <dt>{{ 'TICKETS.MANDATE_HOLDER_INFORMATION.FIRSTNAME' | translate }}</dt>
        <dd data-cy="wizard-summary-mandate-firstname">{{ paymentData.mandateHolderFirstname }}</dd>
        <dt>{{ 'TICKETS.MANDATE_HOLDER_INFORMATION.LASTNAME' | translate }}</dt>
        <dd data-cy="wizard-summary-mandate-lastname">{{ paymentData.mandateHolderLastname }}</dd>
        <dt>{{ 'TICKETS.MANDATE_HOLDER_INFORMATION.DATE_OF_BIRTH' | translate }}</dt>
        <dd data-cy="wizard-summary-mandate-date-of-birth">{{ paymentData.mandateHolderDateOfBirth | date:'dd.MM.yyyy' }}</dd>
        <dt>{{ 'TICKETS.MANDATE_HOLDER_INFORMATION.STREET' | translate }}</dt>
        <dd data-cy="wizard-summary-mandate-street">{{ paymentData.mandateHolderStreet }}</dd>
        @if (paymentData.mandateHolderAddressAddition) {
          <dt>{{ 'TICKETS.MANDATE_HOLDER_INFORMATION.ADDRESS_ADDITION' | translate }}</dt>
          <dd data-cy="wizard-summary-mandate-address-addition">{{ paymentData.mandateHolderAddressAddition }}</dd>
        }
        <dt>{{ 'TICKETS.MANDATE_HOLDER_INFORMATION.POSTAL_CODE' | translate }}</dt>
        <dd data-cy="wizard-summary-mandate-postal-code">{{ paymentData.mandateHolderPostalCode }}</dd>
        <dt>{{ 'TICKETS.MANDATE_HOLDER_INFORMATION.CITY' | translate }}</dt>
        <dd data-cy="wizard-summary-mandate-city">{{ paymentData.mandateHolderCity }}</dd>
        <dt>{{ 'TICKETS.MANDATE_HOLDER_INFORMATION.COUNTRY' | translate }}</dt>
        <dd data-cy="wizard-summary-mandate-country">{{ paymentData.mandateHolderCountry | land }}</dd>
        <dt>{{ 'TICKETS.MANDATE_HOLDER_INFORMATION.BANK_NAME' | translate }}</dt>
        <dd data-cy="wizard-summary-mandate-bank-name">{{ paymentData.mandateHolderBankName }}</dd>
        <dt>{{ 'TICKETS.MANDATE_HOLDER_INFORMATION.IBAN' | translate }}</dt>
        <dd data-cy="wizard-summary-mandate-iban">{{ paymentData.mandateHolderIban }}</dd>
        @if (paymentData.mandateHolderBic) {
          <dt>{{ 'TICKETS.MANDATE_HOLDER_INFORMATION.BIC' | translate }}</dt>
          <dd data-cy="wizard-summary-mandate-bic">{{ paymentData.mandateHolderBic }}</dd>
        }
      </dl>
    </div>
  }

  <div class="alert alert-info" data-cy="wizard-summary-info-hint">
    {{ 'TICKETS.VERIFICATION_WIZARD.SUMMARY.INFO_HINT' | translate }}
  </div>

  <form [formGroup]="form">
    <app-custom-checkbox
      [id]="'confirmed'"
      [customFormGroup]="form"
      [label]="'TICKETS.VERIFICATION_WIZARD.SUMMARY.CONFIRM_LABEL' | translate"
      data-cy="wizard-summary-confirm">
    </app-custom-checkbox>
  </form>
</div>
